import React, { Component } from "react";
import { Dialog } from "primereact/dialog";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import classNames from "classnames";
import { AppTopbar } from "../AppTopbar";
import { AppBreadcrumb } from "../AppBreadcrumb";
import { AppInlineProfile } from "../AppInlineProfile";
import { AppFooter } from "../AppFooter";
import { AppMenu } from "../AppMenu";
import { AppRightPanel } from "../AppRightPanel";
import { Route } from "react-router-dom";
import { withRouter } from "react-router";
import "@fullcalendar/core/main.css";
import "@fullcalendar/daygrid/main.css";
import "@fullcalendar/timegrid/main.css";
import "primeflex/primeflex.css";
import "primereact/resources/primereact.min.css";
import "../ripple.js";
import "../App.css";
import { Trabajador } from "../componentes/Trabajador";
import { Empresa } from "../componentes/empresa/Empresa";
import { EmpresaTrabajadorAfil } from "./EmpresaTrabajadorAfil";
import { Parametro } from "./Parametro";
import { ConsultaMovimientosRegistroPatronal } from "./ConsultaMovimientosRegistroPatronal";
import { MovimientosMasivos } from "./MovimientosMasivos";
import servicioHttp from '../servicio/ServicioHttp';
import { HistoricoDeMovimientos } from './HistoricoDeMovimientos';
import { DetalleMovimientos } from '../componentes/DetalleMovimientos'
import { ConfiguracionSeguridad } from '../componentes/ConfiguracionSeguridad';
import { Bitacora } from '../componentes/Bitacora';
import { Consolidado } from '../componentes/Consolidado';
import { Detalle } from '../componentes/Detalle';
import { Descarga } from '../componentes/Descarga';
import { Lotes } from '../componentes/Lotes';
import { ConsultaMovimientosIndividual } from '../componentes/ConsultaMovimientosIndividual';
import { ExpiracionDeCertificados } from '../componentes/ExpiracionDeCertificados';
import { ConsultaPorMovimientos } from '../componentes/ConsultaPorMovimientos';
import { MovimientosRechazados } from '../componentes/MovimientosRechazados';
import { ConsultaRp } from '../componentes/ConsultaRp';
import { AusentismosIncapacidades } from '../componentes/AusentismosIncapacidades';
import servicioObjetos from '../servicio/ServicioObjetos';
import moment from 'moment';
import servicioFormatos from "../servicio/ServicioFormatos";
import { ExportaSua } from '../componentes/ExportaSua';
import { Confronta } from './confronta/Confronta';
import { AltaEmpresa } from '../componentes/AltaEmpresa';
import { BuscarPatron } from '../componentes/BuscarPatron';
import { SalarioMinimo } from '../componentes/SalarioMinimo';
import { Uma } from '../componentes/Uma';
import { Umi } from '../componentes/Umi';
import { Isr } from '../componentes/Isr';
import { Inpc } from '../componentes/Inpc';
import { TasaRecargo } from '../componentes/TasaRecargo';
import { TablaImssPatron } from '../componentes/TablaImssPatron';

import { TablaImssTrabajador } from '../componentes/TablaImssTrabajador';
import { TablaTopeSGDF } from '../componentes/TablaTopeSGDF';
import { TablaDetalle } from '../componentes/TablaDetalle';
import { AltaTrabajadoresManualSua } from '../componentes/AltaTrabajadoresManualSua';
import { ConfrontaSuaNomina } from '../componentes/ConfrontaSuaNomina';
import { DescargaClienteSua } from '../componentes/DescargaClienteSua';

import { AdministracionUsuarios } from '../componentes/admin/AdministracionUsuarios';
import { ConfiguracionDescargaCfdi } from './descargacfdi/configuracion/ConfiguracionDescargaCfdi';
import { DescargaCfdiSua } from './descargacfdi/cfdisua/DescargaCfdiSua';
import { DescargaCfdiNomina } from './descargacfdi/cfdinomina/DescargaCfdiNomina';
import { MovimientosMasivos2022 } from './movimientosmasivos2022/MovimientosMasivos2022';
import { CensantiaVejezPatronal2023 } from './tablas/cesantiayvejezpatronal/CensantiaVejezPatronal2023';
import { MovimientosManuales2023 } from './movimientosmanuales2023/MovimientosManuales2023';
import { Monitor } from './Monitor';
import { AdmLotes } from "./lotes/administracion/AdmLotes.jsx";
import { TxtCasaLey } from './lotes/casaley/TxtCasaLey';

export default class Bienvenido extends Component {
  constructor() {
    super();
    this.state = {
      layoutMode: "static",
      profileMode: "inline",
      overlayMenuActive: false,
      staticMenuDesktopInactive: false,
      staticMenuMobileActive: false,
      rotateMenuButton: false,
      topbarMenuActive: false,
      activeTopbarItem: null,
      darkMenu: false,
      rightPanelActive: false,
      menuActive: false,
      themeColor: "indigo",
      configDialogActive: false,
      menu: [],
      listaEmpresasVencer: [],
      mostrarModalVencidas: false,
      mostrarModalAsistencia: false,
    };

    this.onDocumentClick = this.onDocumentClick.bind(this);
    this.onMenuClick = this.onMenuClick.bind(this);
    this.onMenuButtonClick = this.onMenuButtonClick.bind(this);
    this.onTopbarMenuButtonClick = this.onTopbarMenuButtonClick.bind(this);
    this.onTopbarItemClick = this.onTopbarItemClick.bind(this);
    this.onMenuItemClick = this.onMenuItemClick.bind(this);
    this.onRootMenuItemClick = this.onRootMenuItemClick.bind(this);
    this.onRightPanelButtonClick = this.onRightPanelButtonClick.bind(this);
    this.onRightPanelClick = this.onRightPanelClick.bind(this);
    this.changeMenuMode = this.changeMenuMode.bind(this);
    this.changeMenuColor = this.changeMenuColor.bind(this);
    this.changeProfileMode = this.changeProfileMode.bind(this);
    this.changeTheme = this.changeTheme.bind(this);
    this.onConfigButtonClick = this.onConfigButtonClick.bind(this);
    this.onConfigCloseClick = this.onConfigCloseClick.bind(this);
    this.onConfigClick = this.onConfigClick.bind(this);
    this.createMenu();
    this.validarVigenciaCertificados();
  }

  onMenuClick(event) {
    this.menuClick = true;
  }

  onMenuButtonClick(event) {
    this.menuClick = true;
    this.setState({
      rotateMenuButton: !this.state.rotateMenuButton,
      topbarMenuActive: false,
    });

    if (this.state.layoutMode === "overlay") {
      this.setState({
        overlayMenuActive: !this.state.overlayMenuActive,
      });
    } else {
      if (this.isDesktop())
        this.setState({
          staticMenuDesktopInactive: !this.state.staticMenuDesktopInactive,
        });
      else
        this.setState({
          staticMenuMobileActive: !this.state.staticMenuMobileActive,
        });
    }

    event.preventDefault();
  }

  onTopbarMenuButtonClick(event) {
    this.topbarItemClick = true;
    this.setState({ topbarMenuActive: !this.state.topbarMenuActive });
    this.hideOverlayMenu();
    event.preventDefault();
  }

  onTopbarItemClick(event) {
    this.topbarItemClick = true;

    if (this.state.activeTopbarItem === event.item)
      this.setState({ activeTopbarItem: null });
    else this.setState({ activeTopbarItem: event.item });

    event.originalEvent.preventDefault();
  }

  onMenuItemClick(event) {
    if (!event.item.items) {
      this.hideOverlayMenu();
    }

    if (!event.item.items && (this.isHorizontal() || this.isSlim())) {
      this.setState({
        menuActive: false,
      });
    }
  }

  onRootMenuItemClick(event) {
    this.setState({
      menuActive: !this.state.menuActive,
    });
  }

  onRightPanelButtonClick(event) {
    this.rightPanelClick = true;
    this.setState({
      rightPanelActive: !this.state.rightPanelActive,
    });
    event.preventDefault();
  }

  onRightPanelClick(event) {
    this.rightPanelClick = true;
  }

  onDocumentClick(event) {
    if (!this.topbarItemClick) {
      this.setState({
        activeTopbarItem: null,
        topbarMenuActive: false,
      });
    }

    if (!this.menuClick) {
      if (this.isHorizontal() || this.isSlim()) {
        this.setState({
          menuActive: false,
        });
      }

      this.hideOverlayMenu();
    }

    if (!this.configClick) {
      this.setState({ configDialogActive: false });
    }

    if (!this.rightPanelClick) {
      this.setState({
        rightPanelActive: false,
      });
    }

    this.topbarItemClick = false;
    this.menuClick = false;
    this.configClick = false;
    this.rightPanelClick = false;
  }

  hideOverlayMenu() {
    this.setState({
      rotateMenuButton: false,
      overlayMenuActive: false,
      staticMenuMobileActive: false,
    });
  }

  isTablet() {
    let width = window.innerWidth;
    return width <= 1024 && width > 640;
  }

  isDesktop() {
    return window.innerWidth > 1024;
  }

  isMobile() {
    return window.innerWidth <= 640;
  }

  isOverlay() {
    return this.state.layoutMode === "overlay";
  }

  isHorizontal() {
    return this.state.layoutMode === "horizontal";
  }

  isSlim() {
    return this.state.layoutMode === "slim";
  }

  onConfigButtonClick(event) {
    this.configClick = true;
    this.setState({ configDialogActive: !this.state.configDialogActive });
  }

  onConfigCloseClick() {
    this.setState({ configDialogActive: false });
  }

  onConfigClick() {
    this.configClick = true;
  }

  changeMenuMode(event) {
    this.setState({ layoutMode: event.menuMode });
    if (event.menuMode === "horizontal") {
      this.setState({ profileMode: "top" });
    }
  }

  changeMenuColor(event) {
    this.setState({ darkMenu: event.darkMenu });
  }

  changeProfileMode(event) {
    this.setState({ profileMode: event.profileMode });
  }

  changeTheme(event) {
    this.setState({ themeColor: event.theme });
    this.changeStyleSheetUrl("layout-css", event.theme, "layout");
    this.changeStyleSheetUrl("theme-css", event.theme, "theme");
  }

  changeStyleSheetUrl(id, value, prefix) {
    let element = document.getElementById(id);
    let urlTokens = element.getAttribute("href").split("/");
    urlTokens[urlTokens.length - 1] = prefix + "-" + value + ".css";
    let newURL = urlTokens.join("/");

    this.replaceLink(element, newURL);
  }

  isIE() {
    return /(MSIE|Trident\/|Edge\/)/i.test(window.navigator.userAgent);
  }

  replaceLink(linkElement, href) {
    if (this.isIE()) {
      linkElement.setAttribute("href", href);
    } else {
      const id = linkElement.getAttribute("id");
      const cloneLinkElement = linkElement.cloneNode(true);

      cloneLinkElement.setAttribute("href", href);
      cloneLinkElement.setAttribute("id", id + "-clone");

      linkElement.parentNode.insertBefore(
        cloneLinkElement,
        linkElement.nextSibling
      );

      cloneLinkElement.addEventListener("load", () => {
        linkElement.remove();
        cloneLinkElement.setAttribute("id", id);
      });
    }
  }

  createMenu() {
    servicioHttp.consumirPostHttp('/accion/menu.json', null).then(response => {
      this.setState({ menu: response.data.lista });
    }).catch(error => {

    });
  }

  validarVigenciaCertificados = () => {
    servicioHttp.consumirPostHttp("empresa/obtener_certificados_vencer.json").then(response => {
      let listaEmpresasVencer = response.data.lista;
      if (!servicioObjetos.esObjetoVacio(listaEmpresasVencer)) {
        this.setState({
          listaEmpresasVencer: listaEmpresasVencer,
          mostrarModalVencidas: true
        });

      }
    }).catch(error => {

    });
  }

  cerrarModal = () => {
    this.setState({ mostrarModalVencidas: false, mostrarModalAsistencia: false });
  }

  renovar = () => {
    this.cerrarModal();
    this.props.history.push("/idsenube/bienvenido/expiraciondecertificados");
  }

  columnaRenovacion = (rowData, column) => {
    return <div>{rowData[0] + " - " + rowData[1]}</div>
  }

  formatoEstadoCertificado(rowData, column) {

    return servicioFormatos.formatoEstadoCertificado(rowData[2], rowData[3]);
  }

  /**
      * Método formatoFecha --> 
      * EStablece el formato de la fecha (YYYY-MM-DD HH:mm:ss)
      * @param {*} rowData 
      * @param {*} column 
      */
  formatoFecha = (rowData, column) => {
    return <div>{servicioFormatos.formatearFecha(rowData[2])}</div>
  }
  formatoDia = (rowData, column) => {
    var fecha1 = moment(rowData[2]);
    const fecha = new Date();
    var fecha2 = moment(fecha);
    var dias = fecha1.diff(fecha2, 'day');
    var diasCortado = Math.abs(dias);
    if (rowData[3] === 2) {
      return <div>El certificado esta revocado.</div>
    } else {
      if (dias < 0) {
        return <div>El certificado expiro hace {diasCortado} días.</div>
      } else {
        return <div>{dias} días para que expire el certificado.</div>
      }
    }
  }
  redirigir = () => {
    window.location.href = "https://idse.imss.gob.mx/imss/";
  }
  asistencia = () => {
    this.setState({ mostrarModalAsistencia: true });
  }
  cerrarAsistencia = () => {
    this.setState({ mostrarModalAsistencia: false });
  }

  render() {
    let piePaginaDialogo = (
      <div className="ui-dialog-buttonpane p-clearfix">
        <Button className="p-button-info" label="Renovar" icon="pi-md-refresh" onClick={this.redirigir} />
        <Button className="p-button-info" label="Asistencia para renovar" icon="pi-md-refresh" onClick={this.asistencia} />
        <Button label="OK" className="p-button-success" icon="pi-md-check" onClick={this.cerrarModal} />
      </div>
    );

    let piePaginaDialogoAsistencia = (
      <div className="ui-dialog-buttonpane p-clearfix">
        <Button label="OK" className="p-button-success" icon="pi-md-check" onClick={this.cerrarAsistencia} />
      </div>
    );



    const layoutContainerClassName = classNames("layout-container", {
      "menu-layout-static": this.state.layoutMode !== "overlay",
      "menu-layout-overlay": this.state.layoutMode === "overlay",
      "layout-menu-overlay-active": this.state.overlayMenuActive,
      "menu-layout-slim": this.state.layoutMode === "slim",
      "menu-layout-horizontal": this.state.layoutMode === "horizontal",
      "layout-menu-static-inactive": this.state.staticMenuDesktopInactive,
      "layout-menu-static-active": this.state.staticMenuMobileActive,
    });
    const menuClassName = classNames("layout-menu", {
      "layout-menu-dark": this.state.darkMenu,
    });
    const AppBreadCrumbWithRouter = withRouter(AppBreadcrumb);
    let { menu, listaEmpresasVencer, mostrarModalVencidas, mostrarModalAsistencia } = this.state;
    return (
      <div>
        <Monitor minutosExpirarSession={5}>
          <div className="layout-wrapper" onClick={this.onDocumentClick}>
            <div ref={(el) => (this.layoutContainer = el)} className={layoutContainerClassName} >
              {
                <AppTopbar
                  profileMode={this.state.profileMode}
                  horizontal={this.isHorizontal()}
                  topbarMenuActive={this.state.topbarMenuActive}
                  activeTopbarItem={this.state.activeTopbarItem}
                  onMenuButtonClick={this.onMenuButtonClick}
                  onTopbarMenuButtonClick={this.onTopbarMenuButtonClick}
                  onTopbarItemClick={this.onTopbarItemClick}
                // onRightPanelButtonClick={this.onRightPanelButtonClick}
                />
              }
              <div className={menuClassName} onClick={this.onMenuClick}>
                <div className="menu-scroll-content">
                  {this.state.profileMode === "inline" &&
                    this.state.layoutMode !== "horizontal" && <AppInlineProfile />}
                  <AppMenu model={menu} onMenuItemClick={this.onMenuItemClick} onRootMenuItemClick={this.onRootMenuItemClick} layoutMode={this.state.layoutMode} active={this.state.menuActive} />
                </div>
              </div>
              <div className="layout-main">
                <AppBreadCrumbWithRouter />
                <div className="layout-content">
                  <Route path="/idsenube/bienvenido/trabajador" component={Trabajador} />
                  <Route path="/idsenube/bienvenido/empresa" component={Empresa} />
                  <Route path="/idsenube/bienvenido/trabajadorempresaafil" component={EmpresaTrabajadorAfil} />
                  <Route path="/idsenube/bienvenido/parametro" component={Parametro} />
                  <Route path="/idsenube/bienvenido/consultamovimientosrp" component={ConsultaMovimientosRegistroPatronal} />
                  <Route path="/idsenube/bienvenido/consultamovimitosinvidual" component={ConsultaMovimientosIndividual} />
                  <Route path="/idsenube/bienvenido/movimientosmasivos" component={MovimientosMasivos} />
                  <Route path="/idsenube/bienvenido/historicodemovimientos" component={HistoricoDeMovimientos} />
                  <Route path="/idsenube/bienvenido/detallemovimientos" component={DetalleMovimientos} />
                  <Route path="/idsenube/bienvenido/configuracionseguridad" component={ConfiguracionSeguridad} />
                  <Route path="/idsenube/bienvenido/bitacora" component={Bitacora} />
                  <Route path="/idsenube/bienvenido/consolidado" component={Consolidado} />
                  <Route path="/idsenube/bienvenido/detalle" component={Detalle} />
                  <Route path="/idsenube/bienvenido/descarga" component={Descarga} />
                  <Route path="/idsenube/bienvenido/lotes" component={Lotes} />
                  <Route path="/idsenube/bienvenido/expiraciondecertificados" component={ExpiracionDeCertificados} />
                  <Route path="/idsenube/bienvenido/consultapormovimientos" component={ConsultaPorMovimientos} />
                  <Route path="/idsenube/bienvenido/movimientosrechazados" component={MovimientosRechazados} />
                  <Route path="/idsenube/bienvenido/rp" component={ConsultaRp} />
                  <Route path="/idsenube/bienvenido/ausentismos" component={AusentismosIncapacidades} />
                  <Route path="/idsenube/bienvenido/exportasua" component={ExportaSua} />
                  <Route path="/idsenube/bienvenido/sua/altaempresa" component={AltaEmpresa} />
                  <Route path="/idsenube/bienvenido/sua/buscarempresa" component={BuscarPatron} />
                  <Route path="/idsenube/bienvenido/salariominimo" component={SalarioMinimo} />
                  <Route path="/idsenube/bienvenido/uma" component={Uma} />
                  <Route path="/idsenube/bienvenido/umi" component={Umi} />
                  <Route path="/idsenube/bienvenido/isr" component={Isr} />
                  <Route path="/idsenube/bienvenido/inpc" component={Inpc} />
                  <Route path="/idsenube/bienvenido/tasarecargo" component={TasaRecargo} />
                  <Route path="/idsenube/bienvenido/tablaimsspatron" component={TablaImssPatron} />

                  <Route path="/idsenube/bienvenido/tablaimsstrabajador" component={TablaImssTrabajador} />
                  <Route path="/idsenube/bienvenido/tablatope" component={TablaTopeSGDF} />
                  <Route path="/idsenube/bienvenido/tabladetalle" component={TablaDetalle} />
                  <Route path="/idsenube/bienvenido/sua/altatrabajadorsua" component={AltaTrabajadoresManualSua} />
                  <Route path="/idsenube/bienvenido/confronta/emisionsua" component={Confronta} />
                  <Route path="/idsenube/bienvenido/confronta/nominasua" component={ConfrontaSuaNomina} />
                  <Route path="/idsenube/bienvenido/descargacliente" component={DescargaClienteSua} />
                  <Route path="/idsenube/bienvenido/admin/usuario" component={AdministracionUsuarios} />
                  <Route path="/idsenube/bienvenido/descargacfdi/configuracion" component={ConfiguracionDescargaCfdi} />
                  <Route path="/idsenube/bienvenido/descargacfdi/cfdisua" component={DescargaCfdiSua} />
                  <Route path="/idsenube/bienvenido/descargacfdi/cfdinomina" component={DescargaCfdiNomina} />
                  <Route path="/idsenube/bienvenido/movimientosmasivosagrupados" component={MovimientosMasivos2022} />
                  <Route path="/idsenube/bienvenido/tablas/cesantiavejezpatronal2023" component={CensantiaVejezPatronal2023} />
                  <Route path="/idsenube/bienvenido/movimientosmanuales" component={MovimientosManuales2023} />
                  <Route path="/idsenube/bienvenido/administracionlotes" component={AdmLotes}/>
                  <Route path="/idsenube/bienvenido/txtcasaley" component={TxtCasaLey}/>
                  <AppFooter />
                </div>
              </div>              
              <AppRightPanel expanded={this.state.rightPanelActive} onContentClick={this.onRightPanelClick} />
              <div className="layout-mask"></div>
            </div>
          </div>
          <Dialog visible={mostrarModalVencidas} style={{ width: '70%' }} header="Atento Aviso" modal={true}
            onHide={this.cerrarModal} footer={piePaginaDialogo}>
            <div className="card card-w-title">
              <DataTable value={listaEmpresasVencer} responsive={true}
                header="Los certificados de los siguientes Registros Patronales estan por expirar o ya expiraron" autoLayout={true}>
                <Column body={this.columnaRenovacion} header="Registro Patronal" />
                <Column header="Fecha de Vencimiento" body={this.formatoFecha} />
                <Column header="Días faltantes de expiración" body={this.formatoDia} />
                <Column header="Estatus" body={this.formatoEstadoCertificado} />
              </DataTable>
            </div>
          </Dialog>
          <Dialog visible={mostrarModalAsistencia} style={{ width: '70%' }} header="SOLICITUD PARA RENOVACIÓN DE CERTIFICADO" modal={true}
            onHide={this.cerrarAsistencia} footer={piePaginaDialogoAsistencia}>
            <div className="card card-w-title">
              <p>ESTIMADO USUARIO:
              </p>
              <p>
                Para que nosotros te apoyemos a realizar  la renovación de tu certificado digital deberas enviar un correo
                <br></br>
                electronico a <strong>support@emica.freshdesk.com</strong> o llamar al télefono <strong>56 1861 7871</strong> y te enviaremos a tu correo el certificado renovado.
              </p>
            </div>
          </Dialog>
        </Monitor>
      </div>
    );
  }
}
